import { render, staticRenderFns } from "./ExtendOtherNutrientsChromium.vue?vue&type=template&id=0dbd22ea&scoped=true"
import script from "./ExtendOtherNutrientsChromium.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsChromium.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsChromium.vue?vue&type=style&index=0&id=0dbd22ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd22ea",
  null
  
)

export default component.exports